import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

const LoginButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    ${breakpoint('xs', 'sm')`
        justify-content: center;
    `}
`;

export default LoginButtonWrapper;



// WEBPACK FOOTER //
// ./src/components/atoms/form/LoginButtonWrapper.js